module.exports = __webpack_public_path__ + "img/sm.f3babfcb.png";